//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../library/umum'
import WILAYAH from  '../../../library/getWilayah'
import uniqid from 'uniqid';

export default {
  data() {
    return {

        form : {
            id : '',
            judul : '',
            uraian : '',
            tahun : '',
            des_kel : '',
            kecamatan : '',
            kelasFile : 'DOKUMEN DESA',
            createdAt : '',
            createdBy : '',
        },


        file : {
          id : '',
          judul : '',
          uraian : '',
          tahun : '',
          des_kel : '',
          kecamatan : '',
          createdAt : '',
          createdBy : '',
          file : null,
          file_type : '',
      },

        fileOld : '',


        
        
        
        
        list_data : [],
        page_limit : 10,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,


        list_data_file : [],
        
        
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_setting : false,
        btn_add: false,
        
        btn_add_file: false,
        
        
        
        mdl_add_file: false,
        mdl_edit_file: false,
        mdl_hapus_file : false,
        mdl_setting_file : false,
        mdl_lihat_file: false,
        mdl_lihat_file_file: false,
        
        UMUM : UMUM,

        disable_kec : false,
        disable_des : false,
    }
  },
  methods: {


      getView : function(){
          this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "view", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  kecamatan : this.form.kecamatan,
                  des_kel : this.form.des_kel,
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value
              })
          })
              .then(res => res.json())
              .then(res_data => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jmlData;
                  this.$store.commit("hideLoading");
                  // console.log(res_data);
          });
      },
  

      addData : function(number) {
      // console.log(this.$store.state.listJenisUsaha) 
          this.form.id = uniqid();
          this.form.createdAt = UMUM.NOW();
          fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "addData", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.form)
          }).then(res_data => {
              this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
              this.getView();
          });
      },


      editData : function(){
          fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "editData", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.form)
          }).then(res_data => {
              this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.getView();
          });
      },

      removeData : function(E){
          fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "removeData", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.form)
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              this.getView();
          });

      },

      selectData : function(data){
              this.form.id = data.id;
              this.form.judul = data.judul;
              this.form.uraian = data.uraian;
              this.form.tahun = data.tahun;
              // this.form.des_kel = data.des_kel;
              // this.form.kecamatan = data.kecamatan;
              this.form.createdAt = data.createdAt;
              this.form.createdBy = data.createdBy;
      },

      emptytData : function(data){

      },

      // ====================================== FILE ====================================

      getView_file : function(){
          this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "view_file", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  desa_dok_permintaanDokumen_id : this.form.id,
                  des_kel : this.form.des_kel,
              })
          })
              .then(res => res.json())
              .then(res_data => {
                  this.list_data_file = res_data;
                  this.$store.commit("hideLoading");
                  console.log(res_data);
          });
      },
  

      addData_file : function(number) {
        var formData = new FormData();

        formData.append("id", uniqid());
        formData.append("desa_dok_permintaanDokumen_id", this.form.id);
        formData.append("judul", this.file.judul);
        formData.append("uraian", this.file.uraian);
        formData.append("des_kel", this.form.des_kel);
        formData.append("createdAt", UMUM.NOW());
        formData.append("file", this.file.file);


        fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "addData_file", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView_file();
        });
      },


      editData_file : function(){
        var formData = new FormData();

        formData.append("id", this.file.id);
        formData.append("judul", this.file.judul);
        formData.append("uraian", this.file.uraian);
        formData.append("tahun", this.file.tahun);
        formData.append("createdAt", this.file.createdAt);
        formData.append("file", this.file.file);

        formData.append("fileOld", this.fileOld);


        fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "editData_file", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
        }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView_file();
        });
      },

      removeData_file : function(E){
          fetch(this.$store.state.url.URL_ADM_DESA_DOK_PENYETORAN + "removeData_file", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.file)
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              this.getView_file();
          });

      },

      selectData_file : function(data){

              this.file.id = data.id;
              this.file.judul = data.judul;
              this.file.uraian = data.uraian;
              this.file.tahun = data.tahun;
              this.file.file_type = data.file_type;
              this.file.des_kel = data.des_kel;
              this.file.kecamatan = data.kecamatan;
              this.file.createdAt = data.createdAt;
              this.file.createdBy = data.createdBy;
              this.fileOld = data.file;
      },

      // ====================================== FILE ====================================


    // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
              this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
              })
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
          indexing : function(index){
              var idx = ((this.page_first-1)*this.page_limit)+index
              return idx
          },

          convert_tgl: function(dateString) {
              var date = new Date(dateString);
              var getBulan = date.getMonth() + 1; var bulan = '';
              if (getBulan == '1') {bulan = 'Jan'} 
              else if(getBulan == '2') {bulan = 'Feb'}
              else if(getBulan == '3') {bulan = 'Mar'}
              else if(getBulan == '4') {bulan = 'Apr'}
              else if(getBulan == '5') {bulan = 'Mei'}
              else if(getBulan == '6') {bulan = 'Jun'}
              else if(getBulan == '7') {bulan = 'Jul'}
              else if(getBulan == '8') {bulan = 'Agt'}
              else if(getBulan == '9') {bulan = 'Sep'}
              else if(getBulan == '10') {bulan = 'Okt'}
              else if(getBulan == '11') {bulan = 'Nov'}
              else if(getBulan == '12') {bulan = 'Des'}

              return date.getDate() + " " + bulan + " " + date.getFullYear();
              // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
          },


    // ====================================== PAGINATE ====================================

    chageDesa(){
      this.form.des_kel = ''
      if (this.form.kecamatan == '' || this.form.kecamatan == undefined || this.form.kecamatan == null) {
        WILAYAH.postDesKelAutocomplete();
      } else {
        WILAYAH.postDesKelAutocomplete(this.form.kecamatan);
        
      }
    },

    filterSelect : function(profile){
      if (profile.aksesWilayah == 0) {
        WILAYAH.getListDesKelFull();
        this.form.des_kel = profile.des_kel
        this.$store.state.ID_DES_KEL = profile.des_kel
        this.disable_des = true
        this.disable_kec = true
      } else if (profile.aksesWilayah == 1) {
        this.form.kecamatan = profile.kecamatan
        WILAYAH.postDesKel(profile.kecamatan)
        this.disable_kec = true
        this.disable_des = false

      } else if (profile.aksesWilayah == 2) {
        WILAYAH.getListDesKelFull();
        this.disable_kec = false
        this.disable_des = false
      }
    },







  },

  mounted () {
          // new FroalaEditor('textarea#froala-editor')
          this.form.tahun = UMUM.getTahun();
          WILAYAH.getListKecamatan();

          var profilex = JSON.parse(localStorage.profile)
          var profile = profilex.profile
          this.$store.state.ID_DES_KEL = profile.des_kel


          this.form.des_kel = profile.des_kel
          this.filterSelect(profile)
  
          this.getView();
  },
}
